import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import DefinitionPage from "@/pages/DefinitionPage";
import CourantsPage from "@/pages/CourantsPage";
import MateriauxPage from "@/pages/MateriauxPage";
import MaterialDetailPage from "@/pages/MaterialDetailPage";
import LexiquePage from "@/pages/LexiquePage";
import GuideAchatPage from "@/pages/GuideAchatPage";
import FaqPage from "@/pages/FaqPage";
import ContactPage from "@/pages/ContactPage";
import CreditsPhotosPage from "@/pages/CreditsPhotosPage";
import InboxPage from "@/pages/InboxPage";
import NotFound from "@/pages/NotFound";
import TermPage from "@/pages/TermPage";
import AnnuairePage from "@/pages/AnnuairePage";
import PartenairesPage from "@/pages/PartenairesPage";
import PartenaireMetierPage from "@/pages/PartenaireMetierPage";
import PartenaireDetailPage from "@/pages/PartenaireDetailPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Suivi d'audience SPA : un page_view à chaque navigation interne.
// Le page_view du chargement initial est déjà envoyé par gtag('config') dans index.html.
const RouteAnalytics = () => {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_location: window.location.href,
        page_path: pathname,
        page_title: document.title,
      });
    }
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain min-h-screen bg-paper font-sans text-ink">
      <BrowserRouter>
        <ScrollToTop />
        <RouteAnalytics />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/definition-sculpteur-contemporain" element={<DefinitionPage />} />
          <Route path="/courants-et-mouvements" element={<CourantsPage />} />
          <Route path="/materiaux-et-techniques" element={<MateriauxPage />} />
          <Route path="/materiaux-et-techniques/:slug" element={<MaterialDetailPage />} />
          <Route path="/lexique-sculpture" element={<LexiquePage />} />
          <Route path="/lexique-sculpture/:slug" element={<TermPage />} />
          <Route path="/partenaires-metiers-d-art" element={<PartenairesPage />} />
          <Route
            path="/partenaires"
            element={<Navigate to="/partenaires-metiers-d-art" replace />}
          />
          <Route path="/partenaires/:slug" element={<PartenaireMetierPage />} />
          <Route path="/partenaires/:metier/:partner" element={<PartenaireDetailPage />} />
          <Route path="/devenez-partenaire-metiers-d-art" element={<AnnuairePage />} />
          <Route
            path="/annuaire-des-metiers-d-art"
            element={<Navigate to="/devenez-partenaire-metiers-d-art" replace />}
          />
          <Route path="/guide-achat-direct-artiste" element={<GuideAchatPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/credits-photos" element={<CreditsPhotosPage />} />
          <Route path="/boite-de-reception" element={<InboxPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
